import gql from 'graphql-tag'
import { ActivityFragment } from '@/graphql/fragments/crm'

export const mutation = gql`
  ${ActivityFragment}
  mutation updateLeadActivity($id: Int!,$fields: crm_lead_activity_set_input!) {
    record: update_crm_lead_activity_by_pk(pk_columns: {id: $id}, _set: $fields) {
      id
    }
  }
`

export default mutation
